import { z } from 'zod';
import { TokenTypeKey } from './token-setting.model';

export enum TokenUseTypeKey {
  TOKEN_CONSUME = 'token_consume',
  ON_DEMAND = 'on_demand',
  FAILED_NO_BUDGET = 'failed_no_budget',
  TOKEN_REFUND = 'token_refund',
  TOKEN_REFUND_MANUAL = 'token_refund_manual',
}

export const TokenUseEventSchema = z.object({
  id: z.number(),
  token_type: z.enum(TokenTypeKey),
  use_type: z.enum(TokenUseTypeKey),
  timestamp: z.string(),
  quantity: z.number(),
  user: z.number(),
  user_email: z.string(),
  allocation: z.number().nullable(),
  on_demand_price_per_token: z.string().nullable(),
  on_demand_total: z.string().nullable(),
  source_id: z.number(),
  source_label: z.string(),
  source_path: z.string().nullable(),
  reverses: z.number().nullable(),
  is_refunded: z.boolean(),
});

export type TokenUseEvent = z.infer<typeof TokenUseEventSchema>;

export type TokenUseEventsSummary = {
  consumed: number;
  refunded: number;
  failed: number;
};

export type PaginatedTokenUseEventsResponse = {
  count: number;
  results: TokenUseEvent[];
  summary: TokenUseEventsSummary;
};
